import { useEffect, useState } from 'react';
import Button from 'jbc-front/components/Button';
import { useEmployeeQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';
import useReactRouter from 'use-react-router';

import { FormerJobs as FormerJobsTemplate } from '@jbc-year-end-adj/2024/features/questions/templates/FormerJobs';
import { ButtonContainer as Buttons } from '@jbc-year-end-adj/2024/features/questions/components/ButtonContainer/ButtonContainer';
import { FormerJobForm } from './Form/Form';
import { FORMER_JOBS } from './query';
import { useEmployeeMutation } from '@jbc-year-end-adj/2024/hooks/graphql/useMutation';
import { ANSWER_FORMER_JOBS } from './Form/mutation';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';
import { LoadingPage } from '../../Loading';

interface FormerJobsProps {
  question: Question;
}

export const FormerJobs = ({ question }: FormerJobsProps) => {
  const { history } = useReactRouter();
  const { data: dataFormerJobs, loading } = useEmployeeQuery(FORMER_JOBS);
  const formerJobs = dataFormerJobs?.request?.profile?.formerJobs;
  const [hasFormerJobs, setHasFormerJobs] = useState(false);
  const [answer] = useEmployeeMutation(ANSWER_FORMER_JOBS);

  useEffect(() => {
    if (formerJobs?.length > 0) {
      setHasFormerJobs(true);
    }
  }, [formerJobs]);

  const checkFormerJobsExist = () => {
    setHasFormerJobs(true);
  };

  const noFormerJobsExist = async () => {
    await answer({ variables: { formerJobs: [] } });
    history.push('/employee_input');
  };

  if (loading) return <LoadingPage />;
  return (
    <FormerJobsTemplate>
      <FormerJobsTemplate.CheckFormerJob question={question}>
        <Buttons>
          <Button huge secondary onClick={() => checkFormerJobsExist()}>
            はい
          </Button>
          <Button
            huge
            secondary
            onClick={() => {
              noFormerJobsExist();
            }}
          >
            いいえ
          </Button>
        </Buttons>
        {hasFormerJobs && <FormerJobForm formerJobs={formerJobs}></FormerJobForm>}
      </FormerJobsTemplate.CheckFormerJob>
    </FormerJobsTemplate>
  );
};
